const themeHeaders = {
    baseWeight: 700,
    thinWeight: 500,
    h1: { mobile: { fs: 32, lh: 36 }, desktop: { fs: 40, lh: 52 } },
    h2: { mobile: { fs: 24, lh: 28 }, desktop: { fs: 32, lh: 40 } },
    h3: { mobile: { fs: 20, lh: 24 }, desktop: { fs: 24, lh: 32 } },
    h4: { mobile: { fs: 16, lh: 20 }, desktop: { fs: 20, lh: 28 } },
    h5: { mobile: { fs: 14, lh: 16 }, desktop: { fs: 16, lh: 24 } },
    h6: { mobile: { fs: 14, lh: 20 }, desktop: { fs: 14, lh: 20 } },
};

export default themeHeaders;
